import { WorkgroupListing } from "../../../amorg-common";

export class WorkgroupListingNode {

    children:WorkgroupListingNode[];

    constructor(
        public workgroup:WorkgroupListing,
    )
    {
        this.children = [];
    }
}

export function getRootNodes(allWorkgroups:WorkgroupListing[]){

    const addChildrenRecursively = (parent:WorkgroupListingNode) => {
        const children = allWorkgroups.filter(wg => wg.parentWorkgroupId === parent.workgroup.id);
        for(const child of children){
            const childNode = new WorkgroupListingNode(child);
            parent.children.push(childNode);
            addChildrenRecursively(childNode);
        }
    }

    const roots = allWorkgroups.filter(wg => wg.parentWorkgroupId === '');
    const rootNodes:WorkgroupListingNode[] = [];
    for(const wg of roots){
        const wgNode = new WorkgroupListingNode(wg);
        addChildrenRecursively(wgNode);
        rootNodes.push(wgNode);
    }
    return rootNodes;
}